export interface Neighborhood {
  title: string;
  slug: string;
  districtNumber: number;
  lat: number;
  lng: number;
}

export default [
  {
    title: "Lancasco",
    slug: "lancasco",
    districtNumber: 7,
    lat: 12.115102,
    lng: -86.258164
  },
  {
    title: "Alumicentro",
    slug: "alumicentro",
    districtNumber: 3,
    lat: 12.142874,
    lng: -86.215328
  },
  {
    title: "Hospital Alemán",
    slug: "hospital-aleman",
    districtNumber: 3,
    lat: 12.146678, 
    lng: -86.218653,
  },
] as Neighborhood[];
